<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="6" cols="7">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
                <b-row>
                    <b-col cols="12">
                        <div class="card-wrapper">
                            <b-card>
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="10">
                                            <h3>{{title}}</h3>
                                        </b-col>
                                        <b-col cols="2">
                                            <i class="fa fa-exclamation-triangle float-right text-red fa-3x" v-if="voucher.is_void == '1'" ></i>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col cols="4" v-if="!disabledField">
                                        <base-input :label="language_terms['DATE']" >
                                            <flat-picker
                                                slot-scope="{ focus, blur }"
                                                @on-open="focus"
                                                @on-close="blur"
                                                style="background-color: white"
                                                class="form-control datepicker"
                                                v-model="voucher.voucher_date"
                                                @on-change="onChangeDate"
                                                ></flat-picker>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="4" v-else>
                                        <base-input :label="language_terms['DATE']" v-model="voucher.voucher_date" disabled type="date"></base-input>
                                    </b-col>
                                    <b-col cols="4">
                                        <base-input :label="language_terms['FINANCIAL_YEAR']" >
                                            <el-select v-model="voucher.fy" filterable :placeholder="language_terms['FINANCIAL_YEAR']" @change="onChangeFinancialYear" disabled>
                                                <el-option v-for="option in valid_fys"
                                                        :key="option.fy"
                                                        :label="option.fy"
                                                        :value="option.fy"
                                                        >
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="4">
                                        <base-input :label="language_terms['REFERENCE']" v-model="voucher.reference" :disabled="disabledField"></base-input>
                                    </b-col>
                                    <b-col cols="12">
                                        <base-input :label="language_terms['REMARKS']">
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="voucher.remarks" :disabled="disabledField"></textarea>
                                        </base-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card>
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="10">
                                            <h3>{{language_terms['GL_ITEMS']}}</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row >
                                    <b-col cols="4" v-if="!disabledField">
                                    <label class="form-control-label">{{language_terms['ACCOUNT']}}</label>
                                        <multiselect
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            open-direction="bottom"
                                            label="display_name"
                                            track-by="code"
                                            :options="account_list"
                                            text-field="display_name"
                                            :multiple="false"
                                            v-model="voucher.account"
                                        ></multiselect>
                                    </b-col>
                                    <b-col cols="3" v-if="!disabledField">
                                        <base-input :label="language_terms['AMOUNT']" v-model="voucher.amount"></base-input>
                                    </b-col>
                                    <b-col cols="4" v-if="!disabledField">
                                        <base-input :label="'aaa'+language_terms['DIRECTION']">
                                            <el-select
                                                v-model="voucher.direction"
                                                filterable
                                                :placeholder="language_terms['DIRECTION']">
                                                <el-option
                                                    v-for="option in direction_options"
                                                    :key="option.code"
                                                    :label="language_terms[option.name]"
                                                    :value="option.code">
                                                </el-option>
                                            </el-select>
                                        </base-input>  
                                    </b-col>
                                    <b-col cols="1" class="mt-4" v-if="!disabledField">
                                        <b-button variant="primary" @click="addItems()" class="mt-2">
                                            {{language_terms['ADD']}}
                                        </b-button>
                                    </b-col>
                                    <b-col cols="12" v-if="voucher.items.length > 0">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['ACCOUNT_CODE']}}</b-th>
                                                <b-th>{{language_terms['ACCOUNT_NAME']}}</b-th>
                                                <b-th>{{language_terms['DEBIT']}}</b-th>
                                                <b-th>{{language_terms['CREDIT']}}</b-th>
                                                <b-th v-if="!disabledField"></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(item, index) in voucher.items" :key="index">
                                                    <td>{{item.account_item_code}}</td>
                                                    <td>{{item.account_display_name}}</td>
                                                    <td>{{item.db_amount}}</td>
                                                    <td>{{item.cr_amount}}</td>
                                                    <td v-if="!disabledField">
                                                        <base-button  size="sm" icon type="danger" @click="deleteItem(index)"><i class="fas fa-trash-alt"></i ></base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
    
                                    </b-col>
                                </b-row>
                                
                            </b-card>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <b-button class="transparent-btn" @click="save" v-if="!disabledField">
                            <i class="fas fa-save mr-2 text-success"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn" @click="voidVoucher" v-if="allowVoid">
                            <i class="fa fa-ban mr-2 text-warning"></i>{{language_terms['VOID']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancelVoucher">
                            <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";
import moment from "moment";

export default {
 components:{
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            voucher_filter:(state)=>state.vouchers.gl_voucher_filter,
            account_data: state => state.accounts.data,
            is_created: state => state.vouchers.is_created,
            is_voided: state => state.vouchers.is_voided,
            voucher_data: state => state.vouchers.data,
            fys: (state) => state.accounts.fys,
            accounts_for_fy: (state) => state.accounts.accounts_for_fy,
            fy_by_date: (state) => state.accounts.fy_by_date
        })
    },
    data(){
       return{
           loading:false,
           allowVoid:false,
           title:"",
           valid_fys:[],
           account_list:[],
           direction_options:[
              {code: "DR", name:"DEBIT"},
              {code: "CR", name:"CREDIT"}
            ],
           disabledField:false,
           voucher:{
               account:"",
               voucher_code:"",
               voucher_date:null,
               voucher_type:"GL",
               reference:"",
               amount:"",
               remarks:"",
               items:[],
               account_item_code:"",
               account_item_id:"",
               fy:"",
               direction:"DR",
           }
       }
   },
   async mounted()
   {
        let id = this.$route.params.id

        if(id == '_new')
        {
            this.title = this.language_terms['NEW_GL_VOUCHER']
            this.voucher.voucher_date = moment().format("YYYY-MM-DD")

            await this.$store.dispatch("accounts/fetchFYs", {})

            if(this.fys)
            {
                this.valid_fys = this.fys.filter(function(item)
                {
                    return (item.fy != null);
                });

                this.voucher.fy = this.valid_fys[0].fy
                this.getAllAccountsForFY()
            }
        }
        else
        {
            await this.$store.dispatch("vouchers/fetchVoucher", {voucher_code: id})
            this.voucher = this.voucher_data
            this.title = this.voucher.voucher_code
            this.disabledField = true

            if(this.voucher.allow_void)
            {
                this.allowVoid = true
            }
        }

   },
   methods:{
        async onChangeDate()
        {   
            //console.log(this.voucher.voucher_date)
            await this.$store.dispatch("accounts/getFyByDate", {date:this.voucher.voucher_date})

            //console.log(this.fy_by_date)

            if(this.fy_by_date)
            {
                this.voucher.fy = this.fy_by_date.fy
                this.getAllAccountsForFY()

            }
        },
        async searchVouchers()
        {
            this.isLoading = true
            let filter = {
                keyword:"",
                    active_only:"1",
                    type:"GL"
            }
            if(this.voucher_filter)
            {
                filter = this.voucher_filter
            }
            await this.$store.dispatch('vouchers/quickSearch', filter)

            this.isLoading = false
        },
        cancelVoucher()
        {
            this.$router.push("/finance/gl-vouchers")
        },
      async voidVoucher()
      {
        await this.$store.dispatch("vouchers/voidVoucher", {id:this.voucher.id})

            if(this.is_voided == 1)
            {
                await this.searchVouchers()
                this.$router.push("/finance/gl-vouchers")
            }
      },
      deleteItem(index)
      {
        this.voucher.items.splice(index, 1);
      },
      addItems()
      {
          if(this.voucher.account)
          {
            let db_amount = null
            let cr_amount = null

            if(this.voucher.direction == 'DR')
            {
                db_amount = this.voucher.amount
                cr_amount = ''
            }
            else if(this.voucher.direction == 'CR')
            {
                cr_amount = this.voucher.amount
                db_amount = ''
            }


            this.voucher.items.push({
                account_item_code:this.voucher.account.code,
                account_item_id:this.voucher.account.id,
                account_display_name:this.voucher.account.display_name,
                amount:this.voucher.amount,
                direction:this.voucher.direction,
                db_amount:db_amount,
                cr_amount:cr_amount
            })

            this.voucher.account = ''
            this.voucher.account_item_code = ''
            this.voucher.amount = ''
            // this.voucher.direction = ''
          }
      },
      onChangeFinancialYear()
      {
        this.getAllAccountsForFY()
      },
      async getAllAccountsForFY()
      {
        this.loading = true;
        let filter = {fy:this.voucher.fy}
        await this.$store.dispatch("accounts/getAccountForFys", filter)
        this.account_list = this.accounts_for_fy

        this.loading = false;
      },
      async save()
      {
        await this.$store.dispatch("vouchers/create", this.voucher)

        if(this.is_created == 1)
        {
            await this.searchVouchers()
            this.$router.push("/finance/gl-vouchers")
        }
      }
   }
}
</script>
